module.exports = __webpack_public_path__ + "img/teacherIcon1.062d484d.jpg";